import { render, staticRenderFns } from "./AcademySettings.vue?vue&type=template&id=210ef868&scoped=true"
import script from "./AcademySettings.vue?vue&type=script&lang=js"
export * from "./AcademySettings.vue?vue&type=script&lang=js"
import style0 from "./AcademySettings.vue?vue&type=style&index=0&id=210ef868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210ef868",
  null
  
)

export default component.exports